module.exports = __webpack_public_path__ + "static/media/11.101.db4a70f1.jpg";